import api from "../lib/api";

export const clientService = {
    getAllClients: () => api.get('/company/client/all'),
    createClient: (data) => api.post('/company/client', data),
    updateClient: (id, data) => api.put(`/company/client/${id}`, data),
    getStates: () => api.get('/user/states'),
    getCitiesByState: (stateId) => api.get(`/user/states/${stateId}/cities`),
    getAllCities: () => api.get('/user/cities'),
    getClientById(id) {
        return api.get(`/company/client/${id}`);
    },
    deleteClient: (id) => api.delete(`/company/client/${id}`),
};
